<template lang="html">
	<div class="container-fluid p-5">
		<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">
						<h6><a href="javascript:void(0)" class="text-info" @click="back()"> <i class="fas fa-arrow-left"></i></a> Edit E-News Letter</h6>
					</div>
					<div class="card-body">
						<form v-on:submit.prevent="onSubmit">
							<div class="form-group row">
								<label for="inputName" class="col-sm-2 col-form-label">နာမည် <span class="text-danger">*</span></label>
								<div class="col-sm-10">
									<input type="text" v-model="enewsRequest.name" @blur="validationRule()"
										class="form-control" id="inputName">
									<small class="text-danger">{{validationData.name}}</small>
								</div>
							</div>

							<div class="form-group row">
								<label for="inputupload_date" class="col-sm-2 col-form-label">ရက်စွဲ<span class="text-danger">*</span></label>
								<div class="col-sm-10">
									<input type="date" v-model="enewsRequest.upload_date" @blur="validationRule()"
										class="form-control" id="inputupload_date">
									<small class="text-danger">{{validationData.upload_date}}</small>
								</div>
							</div>

							<div class="form-group row">
								<label for="inputFile" class="col-sm-2 col-form-label">ဖိုင် </label>
								<div class="col-sm-10">
									<input type="file" class="form-control" id="inputFile" @change="readFile">
									<img v-if="enewsRequest.file" v-bind:src="enewsRequest.file" class="banner-file mt-2"/>
								</div>
							</div>

							<div class="form-group row">
								<label class="col-sm-2 col-form-label"> ဖိုင်အဟောင်း </label>
								<div class="col-sm-10">
									<a v-if="currentFile" :href="env.mediaUrl+currentFile" target="_blank">ဖိုင်အဟောင်း ကြည့်ရန် </a>
								</div>
							</div>

							<button type="submit" class="btn btn-primary float-save">လုပ်ဆောင်မည်</button>
						</form>
					</div>
				</div>
			</div>
		</div>
		<b-modal ref="my-modal" hide-backdrop hide-footer>
			<template v-slot:modal-name>
				Alert
			</template>
			<div class="d-block text-center">
				<p>You must fill out the required fields before making other changes.</p>
			</div>
		</b-modal>
	</div>
</template>

<script lang="js">
	import {
		mapState,
		mapActions
	} from 'vuex'
	import env from '../../enviorments'
	import Loading from 'vue-loading-overlay'
	import 'vue-loading-overlay/dist/vue-loading.css';
	export default {
		name: 'enewsEdit',
		metaInfo: {
            title: "enews Edit",
            titleTemplate: "%s ← SC Dashboard",
        },
		components: {
			Loading
		},
		data() {
			return {
				env,
				isLoading: false,
				fullPage: true,
				currentFile: "",
				filter: {
					page: "",
                    reverse: "",
                    sort: "",
                    name: ""
				},
				enewsRequest: {
					id: "",
					name: "",
					upload_date: "",
					file: ""
				},
				validationData: {
					name: "",
					upload_date: ""
				}
			}
		},
		watch: {
			async $route(to, from) {
			},
		},
		computed: {},
		methods: {
			...mapActions({
				enewsUpdateAction: 'enewsUpdateAction',
				enewsFieldsAction: 'enewsFieldsAction'
			}),
			readFile({ target }) {
				const files = target.files
				const fileReader = new FileReader()
				fileReader.readAsDataURL(files[0])
				fileReader.onload = e => {
					this.enewsRequest.file = e.target.result
				};
			},
			async getFields(){
				let option = {
					fields: {id: this.enewsRequest.id}
				}
				await this.enewsFieldsAction({
					...option
				}).then(res => {
					this.enewsRequest.name = res.data.name
					this.enewsRequest.upload_date = res.data.upload_date
					this.currentFile = res.data.file
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			async onSubmit() {
				this.isLoading = true
				let validation = this.validationRule()
				if (validation == true) {
					this.isLoading = false
					return
				}
				let option = this.enewsRequest
				await this.enewsUpdateAction({
					...option
				}).then(res => {
					this.back()
					this.isLoading = false;
				}).catch(err => this.isLoading = true)
			},
			back() {
				this.$router.replace({ path: 'enews-list', query: { page: this.filter.page, reverse: this.filter.reverse, sort: this.filter.sort, name: this.filter.name} }).catch(()=>{})
			},
			validationRule() {
				let isValidation = []
				if (this.enewsRequest.name == "") {
					this.validationData.name = "The name field is required."
					isValidation.push(true)
				} else {
					this.validationData.name = ""
					isValidation.push(false)
				}
				if (this.enewsRequest.upload_date == "") {
					this.validationData.upload_date = "The upload_date field is required."
					isValidation.push(true)
				} else {
					this.validationData.upload_date = ""
					isValidation.push(false)
				}

				if (isValidation.includes(true)) {
					return true
				} else {
					return false
				}
			}
		},
		async mounted() {
			this.filter.page = this.$route.query.page
            this.filter.reverse = this.$route.query.reverse
            this.filter.sort = this.$route.query.sort
			this.enewsRequest.id = this.$route.query.id
			this.filter.name = this.$route.query.name
			this.getFields()
		}
	}
</script>

<style scoped lang="scss">
	.v-text-field--box .v-input__slot,
	.v-text-field--outline .v-input__slot {
		min-height: 56px;
	}
	.banner-file {
		width: 100px;
		height: 100px;
		object-fit: contain;
	}
</style>